import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";

const cache = new Map();

export function WerberCrown({ userId }) {
  const [c, setC] = useState(cache.get(userId));
  useEffect(() => {
    if (!userId || cache.has(userId)) return;
    api.get(`/growth/crown/${userId}`).then(({ data }) => { cache.set(userId, data); setC(data); }).catch(() => {});
  }, [userId]);
  if (!c) return null;
  const month = new Date(`${c.month}-01T12:00:00`).toLocaleDateString("de-DE", { month: "long" });
  return (
    <span title={`Top-Werber im ${month}`} data-testid="werber-crown" className="inline-flex items-center gap-1 h-6 px-2.5 rounded-full text-[11px] font-extrabold text-amber-900 bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-400 shadow-sm shadow-amber-300/60 ring-1 ring-amber-300">
      <Crown className="w-3.5 h-3.5" fill="currentColor" /> Top-Werber {month}
    </span>
  );
}
